import * as React from 'react';

export default function PadelRacket({
  className,
  viewBox = '0 0 20 20',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className={className} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.45949 5.81459C4.10187 2.49889 9.90763 0.385799 12.531 2.51282C14.28 3.93095 14.8909 6.17408 14.364 9.24244L12.7491 14.9667L14.0355 18.5008C13.9861 18.9297 12.918 19.3185 12.6045 19.0217L11.2977 15.495L11.6932 14.3237L12.4182 11.7997C11.7092 12.6742 10.6206 13.0704 9.51533 12.8563L11.6932 14.3237L11.2977 15.495L6.38114 12.148C4.00508 10.1362 3.04431 7.95747 3.45949 5.81459Z"
        fill="currentColor"
      />
    </svg>
  );
}
